import { ScheduleGridBodyCellProps } from "components/ScheduleGrid/ScheduleGrid.Types";
import { injectStores, Tooltip } from "@intrasync/react";
import { RootStore, ServiceStore } from "@intrasync/stores";
import type { RouterStore } from "@intrasync/stores";

interface ProductionOverviewLeftBodyCellProps
  extends ScheduleGridBodyCellProps {
  scheduleDate: number; // This is now the job number (row identifier)
  rowCount: number;
  rowData: {
    schedulerDate: number;
    entities: { jobNumber: number }[];
  };
  routerStore?: RouterStore;
  rootStore?: RootStore;
}

interface CurrentClient {
  shortName?: string;
  name?: string;
  jobNumber: number;
}

const ProductionOverviewLeftBodyCellImpl = (
  props: ProductionOverviewLeftBodyCellProps
) => {
  const { rowCount, scheduleDate, rowData, routerStore, rootStore } = props;
  const backgroundColor = props.rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";

  // scheduleDate is now the job number (row identifier)
  const jobNumber = scheduleDate || rowData?.schedulerDate;

  // Get job/client info
  const jobStore = rootStore?.jobStore as ServiceStore;
  const currentClient = jobStore?.entities?.find(
    (i) => i.jobNumber === jobNumber
  ) as unknown as CurrentClient | undefined;

  const displayName = currentClient?.shortName || currentClient?.name || `Job ${jobNumber}`;

  const handleClick = () => {
    if (routerStore && jobNumber) {
      routerStore.goTo("ProjectDashboard", {
        jobNumber: jobNumber,
      });
    }
  };

  return (
    <div
      style={{
        border: "1px solid #eee",
        ...props.style,
        ...props.styles,
        backgroundColor,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding: "4px 8px",
      }}
    >
      <Tooltip title={`Navigate to Job ${jobNumber}`}>
        <b
          style={{ cursor: "pointer", fontSize: "13px" }}
          onClick={handleClick}
        >
          {displayName}
        </b>
      </Tooltip>
      {rowCount >= 1 && (
        <span style={{ fontSize: "11px", color: "#666" }}>
          {rowCount} {rowCount === 1 ? "piece" : "pieces"}
        </span>
      )}
    </div>
  );
};

const ProductionOverviewLeftBodyCell = injectStores(ProductionOverviewLeftBodyCellImpl);

export default ProductionOverviewLeftBodyCell;
